import { CardData } from 'data/types/CardData';

export const formatAnnualFee = (cardData: CardData): string => {
  const annualFee =
    cardData.fees?.annual_fee_amount_dollars ?? cardData.annualFee ?? 0;
  const isWaivedFirstYear =
    cardData.fees?.annual_fee_waived_first_year ?? false;

  if (annualFee === 0) {
    return 'No AF';
  }

  if (isWaivedFirstYear) {
    return `$0 first year\n$${annualFee} after`;
  }

  return `$${annualFee} AF`;
};

export const formatAnnualFeeForMobile = (cardData: CardData): string => {
  const annualFee =
    cardData.fees?.annual_fee_amount_dollars ?? cardData.annualFee ?? 0;
  const isWaivedFirstYear =
    cardData.fees?.annual_fee_waived_first_year ?? false;

  if (annualFee === 0) {
    return 'No AF';
  }

  if (isWaivedFirstYear) {
    return `$0 AF first year, then $${annualFee}`;
  }

  return `$${annualFee} AF`;
};
